import { httpRequest } from '../../../../app/common/util/api-common.util';

class NotasAPI {
  static cancelamentoNotas(laudo, justificativa) {
    return httpRequest(`laudos/${laudo}/etapas/notas/cancelamento`, 'PATCH', {
      justificativa: justificativa,
    }).then((json) => json.data);
  }
}

export default NotasAPI;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/notas/notas.api.js